// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS component */
.EditableValue-module__InnerContainer__UNanf {
    display: flex;
    gap: var(--ds-s);
    align-items: center;
    width: 100%;
}

.EditableValue-module__Button__DE08e {
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    /* We need this 9px in order to achieve the overall 48px height */
    padding: var(--ds-3x) var(--ds-14x) var(--ds-3x) var(--ds-m);
    color: var(--ds-input-field-text-color);
    font-size: var(--ds-font-size-m);
    background: var(--ds-input-field-bg-color);
    border-radius: var(--ds-border-radius-sm);
    box-shadow: 0 0 0 var(--ds-border-width) var(--ds-input-field-border-color)
        inset;
    cursor: pointer;
    transition:
        box-shadow var(--ds-transition-s) ease-in-out,
        color var(--ds-transition-s) ease-in-out;
}

.EditableValue-module__Button__DE08e:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-hover-border-color) inset;
}

.EditableValue-module__Button__DE08e:focus-visible {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.EditableValue-module__Button__DE08e:disabled {
    color: var(--ds-input-field-disabled-text-color);
    background: var(--ds-input-field-disabled-bg-color);
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
    cursor: default;
}

.EditableValue-module__Content__Wqtcr {
    min-height: var(--ds-l);
    line-height: var(--ds-line-height-big);
}

.EditableValue-module__PlaceholderText__GcUHv {
    color: var(--ds-input-field-placeholder-color);
}

.EditableValue-module__LabelDefault__YMiLr {
    margin-left: var(--ds-xs);
    color: var(--ds-input-field-placeholder-color);
    font-weight: var(--ds-font-weight-regular);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height-big);
}

.EditableValue-module__Icon__HQdiS {
    position: absolute;
    top: 50%;
    right: var(--ds-m);
    color: var(--ds-input-field-icon-color);
    transform: translateY(-50%);
    transition: all var(--ds-transition-s) ease-in-out;
}
/* stylelint-disable-next-line selector-max-specificity -- DS component */
.EditableValue-module__Button__DE08e:focus .EditableValue-module__Icon__HQdiS {
    color: var(--ds-input-field-focused-icon-color);
}
/* stylelint-disable-next-line selector-max-specificity -- DS component  */
.EditableValue-module__Button__DE08e:hover .EditableValue-module__Icon__HQdiS {
    color: var(--ds-input-field-focused-icon-color);
}
/* stylelint-enable property-disallowed-list -- DS component */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"InnerContainer": `EditableValue-module__InnerContainer__UNanf`,
	"Button": `EditableValue-module__Button__DE08e`,
	"Content": `EditableValue-module__Content__Wqtcr`,
	"PlaceholderText": `EditableValue-module__PlaceholderText__GcUHv`,
	"LabelDefault": `EditableValue-module__LabelDefault__YMiLr`,
	"Icon": `EditableValue-module__Icon__HQdiS`
};
export default ___CSS_LOADER_EXPORT___;
